import { asyncScope } from "../lib/utils";

export const scopeScope = asyncScope.scope("scope");
